module.exports = require('./lib/axios');


//////////////////
// WEBPACK FOOTER
// /home/circleci/repo/~/axios/index.js
// module id = 867
// module chunks = 168707334958949